import { forwardRef } from 'react';
import styled from 'styled-components';
import { flexbox, space } from 'styled-system';

import { useGridContext } from 'hb-react/shared/components/DesignSystem/Grid/contexts/GridContext';
import {
  type RowProps,
  type RowStyledProps,
} from 'hb-react/shared/components/DesignSystem/Grid/types';
import { getBpNum } from 'hb-react/shared/components/DesignSystem/Grid/utils/getBpNum';

export const Row = forwardRef<HTMLDivElement, RowProps>(
  ({ children, justifyCenter, ...otherProps }, ref) => {
    const { colGap, columnsInMobile } = useGridContext();

    return (
      <RowStyled
        flexDirection={{
          _: columnsInMobile ? 'row' : 'column',
          m: 'row',
          l: 'row',
          xl: 'row',
        }}
        justifyContent={justifyCenter ? 'center' : 'flex-start'}
        ml={{
          _: columnsInMobile ? getBpNum(colGap, '_') * -1 : 0,
          m: getBpNum(colGap, 'm') * -1,
          l: getBpNum(colGap, 'l') * -1,
          xl: getBpNum(colGap, 'xl') * -1,
        }}
        {...otherProps}
        ref={ref}
      >
        {children}
      </RowStyled>
    );
  },
);

export default Row;

const RowStyled = styled.div<RowStyledProps>`
  ${flexbox}
  ${space}

  display: flex;
  flex-wrap: wrap;
  height: ${({ height }) => height || '100%'};
  position: relative;
`;
